import SubscribeForm from '@/components/feature/SubscribeForm';

export default function SubscribeSection() {
  return (
    <section className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="overflow-hidden rounded-card bg-primary-950 px-6 py-10 md:px-12 md:py-14">
          <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
            <div className="lg:col-span-6">
              <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-primary-950">
                <i className="ri-mail-send-line" />
                瓜报订阅
              </span>
              <h2 className="mt-4 font-heading text-2xl tracking-wide text-background-50 md:text-[34px]">
                每天一封瓜报，只挑值得看的那几条
              </h2>
              <p className="mt-3 max-w-lg text-sm leading-relaxed text-background-300">
                我们把当天最热的八卦、剧集口碑和名场面，压缩成一封三五分钟能读完的邮件。不刷屏，不带节奏，随时退订。
              </p>
            </div>
            <div className="lg:col-span-6">
              <SubscribeForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}